module.exports = to_utf8;
var out = [],
    col = [],
    fcc = String.fromCharCode,
    mask = [0x40, 0x20, 0x10, 0x08, 0x04, 0x02, 0x01],
    unmask = [0x00, 0x01, 0x02 | 0x01, 0x04 | 0x02 | 0x01, 0x08 | 0x04 | 0x02 | 0x01, 0x10 | 0x08 | 0x04 | 0x02 | 0x01, 0x20 | 0x10 | 0x08 | 0x04 | 0x02 | 0x01, 0x40 | 0x20 | 0x10 | 0x08 | 0x04 | 0x02 | 0x01];

function to_utf8(bytes, start, end) {
  start = start === undefined ? 0 : start;
  end = end === undefined ? bytes.length : end;
  var idx = 0,
      hi = 0x80,
      collecting = 0,
      pos,
      by;
  col.length = out.length = 0;

  while (idx < bytes.length) {
    by = bytes[idx];

    if (!collecting && by & hi) {
      pos = find_pad_position(by);
      collecting += pos;

      if (pos < 8) {
        col[col.length] = by & unmask[6 - pos];
      }
    } else if (collecting) {
      col[col.length] = by & unmask[6];
      --collecting;

      if (!collecting && col.length) {
        out[out.length] = fcc(reduced(col, pos));
        col.length = 0;
      }
    } else {
      out[out.length] = fcc(by);
    }

    ++idx;
  }

  if (col.length && !collecting) {
    out[out.length] = fcc(reduced(col, pos));
    col.length = 0;
  }

  return out.join('');
}

function find_pad_position(byt) {
  for (var i = 0; i < 7; ++i) {
    if (!(byt & mask[i])) {
      break;
    }
  }

  return i;
}

function reduced(list) {
  var out = 0;

  for (var i = 0, len = list.length; i < len; ++i) {
    out |= list[i] << (len - i - 1) * 6;
  }

  return out;
}